import React, { useEffect, useState } from 'react';

const YT_BASE = 'https://www.googleapis.com/youtube/v3';
const getApiKey = () => (
  process.env.REACT_APP_YOUTUBE_API_KEY ||
  (typeof window !== 'undefined' ? window.__YOUTUBE_API_KEY__ : '') ||
  localStorage.getItem('YOUTUBE_API_KEY') || ''
);
const ytGet = async (endpoint, params) => {
  const url = new URL(`${YT_BASE}/${endpoint}`);
  Object.entries({ ...params, key: getApiKey() }).forEach(([k, v]) => url.searchParams.set(k, v));
  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return await res.json();
};

const CHANNEL_PRESETS = [
  { id: 'futbol', label: 'Futbol / Spor', queries: ['futbol maçı', 'süper lig', 'fenerbahçe galatasaray', 'Batuhan Eke', 'Yağız Sabuncuoğlu', 'beIN SPORTS', 'TRT Spor'], categoryId: '17' },
  { id: 'dizi', label: 'Dizi / Eğlence', queries: ['türk dizisi', 'yerli dizi', 'dizi fragman', 'netflix türk', 'dizi yorum'], categoryId: '24' },
  { id: 'moda', label: 'Moda / Lifestyle', queries: ['erkek moda', 'erkek giyim', 'stil önerileri', 'moda vlog', 'outfit'], categoryId: '24' },
  { id: 'prestijli', label: 'Prestijli / İçerik Üretici', queries: ['Batuhan Eke', 'Yağız Sabuncuoğlu', 'Türk futbol YouTuber', 'futbol içerik üretici', 'cocguk'], categoryId: '' },
];

function exportChannelsToCSV(channels, presetLabel) {
  if (!channels || channels.length === 0) return;
  const exportData = channels.map((ch) => ({
    channelTitle: ch.channelTitle || '',
    channelId: ch.channelId || '',
    channelUrl: ch.channelId ? `https://www.youtube.com/channel/${ch.channelId}` : '',
    subscribers: ch.subs != null ? ch.subs : '',
    totalViews: ch.totalViews != null ? ch.totalViews : '',
    videoCount: ch.videoCount != null ? ch.videoCount : '',
    thumbnailUrl: ch.thumb || '',
    category: presetLabel || '',
  }));
  const headers = Object.keys(exportData[0]);
  const csvRows = [
    headers.join(','),
    ...exportData.map((row) =>
      headers
        .map((h) => {
          const val = row[h] ?? '';
          const str = String(val).replace(/"/g, '""');
          return /[,"\n]/.test(str) ? `"${str}"` : str;
        })
        .join(',')
    ),
  ];
  const blob = new Blob(['\uFEFF' + csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `jakamen_youtube_kanallari_${presetLabel || 'export'}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export default function BrandingPlanJakamen250K() {
  const formatTL = (n, fd = 0) => `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: fd, maximumFractionDigits: fd })}`;
  const formatInt = (n) => Number(Math.round(n || 0)).toLocaleString('tr-TR');

  const [channelPreset, setChannelPreset] = useState('futbol');
  const [channelSearch, setChannelSearch] = useState('');
  const [channels, setChannels] = useState([]);
  const [selectedChannelIds, setSelectedChannelIds] = useState(() => new Set());
  const [channelLoading, setChannelLoading] = useState(false);
  const [channelError, setChannelError] = useState(null);

  const toggleChannelSelection = (channelId) => {
    setSelectedChannelIds((prev) => {
      const next = new Set(prev);
      if (next.has(channelId)) next.delete(channelId);
      else next.add(channelId);
      return next;
    });
  };
  const selectAllChannels = () => setSelectedChannelIds(new Set(channels.map((c) => c.channelId).filter(Boolean)));
  const clearSelection = () => setSelectedChannelIds(new Set());

  const fetchChannelsByTopic = async (queries, categoryId) => {
    setChannelLoading(true);
    setChannelError(null);
    setSelectedChannelIds(new Set());
    try {
      const chMap = new Map();
      for (const q of queries) {
        let pageToken = '';
        for (let page = 0; page < 2; page++) {
          // order=viewCount + videoCategoryId can cause 400 "Invalid combination" - use relevance when filtering by category
          const s = await ytGet('search', {
            part: 'snippet',
            type: 'video',
            q,
            regionCode: 'TR',
            order: categoryId ? 'relevance' : 'viewCount',
            maxResults: 50,
            pageToken: pageToken || undefined,
            ...(categoryId ? { videoCategoryId: categoryId } : {}),
          });
          const ids = (s.items || []).map(it => it.id?.videoId).filter(Boolean);
          if (ids.length > 0) {
            const d = await ytGet('videos', { part: 'snippet,statistics', id: ids.join(',') });
            for (const it of d.items || []) {
              const chId = it.snippet?.channelId;
              if (!chId) continue;
              const chTitle = it.snippet?.channelTitle || chId;
              const views = Number(it.statistics?.viewCount || 0);
              if (!chMap.has(chId)) chMap.set(chId, { channelId: chId, channelTitle: chTitle, totalViews: 0, videoCount: 0 });
              const obj = chMap.get(chId);
              obj.totalViews += views;
              obj.videoCount += 1;
              if (!obj.thumb && it.snippet?.thumbnails) {
                const th = it.snippet.thumbnails;
                obj.thumb = th.high?.url || th.medium?.url || th.default?.url || '';
              }
            }
          }
          pageToken = s.nextPageToken || '';
          if (!pageToken) break;
        }
        const chSearch = await ytGet('search', {
          part: 'snippet',
          type: 'channel',
          q,
          regionCode: 'TR',
          order: 'relevance',
          maxResults: 25,
        });
        for (const it of chSearch.items || []) {
          const chId = it.id?.channelId;
          if (!chId) continue;
          const chTitle = it.snippet?.channelTitle || chId;
          if (!chMap.has(chId)) chMap.set(chId, { channelId: chId, channelTitle: chTitle, totalViews: 0, videoCount: 0 });
        }
      }
      let list = Array.from(chMap.values()).sort((a, b) => b.totalViews - a.totalViews);
      try {
        const toShow = list.slice(0, 250);
        const ids = toShow.map(c => c.channelId).filter(Boolean);
        const info = new Map();
        for (let i = 0; i < ids.length; i += 50) {
          const chunk = ids.slice(i, i + 50);
          const r = await ytGet('channels', { part: 'snippet,statistics', id: chunk.join(',') });
          for (const it of r.items || []) {
            const th = it.snippet?.thumbnails || {};
            info.set(it.id, {
              thumb: th.default?.url || th.medium?.url || th.high?.url || '',
              subs: Number(it.statistics?.subscriberCount || 0),
            });
          }
        }
        list = list.map(c => ({ ...c, ...info.get(c.channelId) || {} }));
      } catch (_) {}
      setChannels(list.slice(0, 250));
    } catch (e) {
      // Fallback to backend on 403 (quota) or 400 (invalid params / API key issues)
      if ((e?.message || '').includes('403') || (e?.message || '').includes('400')) {
        try {
          const brandId = localStorage.getItem('currentBrandId') || '';
          const token = localStorage.getItem('token') || '';
          const headers = { 'Content-Type': 'application/json' };
          if (token) headers['Authorization'] = `Bearer ${token}`;
          if (brandId) headers['X-Brand-ID'] = brandId;

          const chMap = new Map();
          for (const q of queries.slice(0, 5)) {
            if (!q || !String(q).trim()) continue;
            const r = await fetch(
              `https://api.glowytics.com/api/google-ads/youtube/trends/search?q=${encodeURIComponent(q)}&region=TR&maxResults=50`,
              { credentials: 'include', headers }
            );
            const j = await r.json().catch(() => ({}));
            if (!r.ok) {
              if (j?.error === 'q_required') continue;
              throw new Error(j?.error || j?.details || `HTTP ${r.status}`);
            }
            if (Array.isArray(j.items)) {
              for (const v of j.items) {
                const chId = v.channelId;
                if (!chId) continue;
                const chTitle = v.channelTitle || chId;
                const views = Number(v.statistics?.viewCount || 0);
                if (!chMap.has(chId)) chMap.set(chId, { channelId: chId, channelTitle: chTitle, totalViews: 0, videoCount: 0 });
                const obj = chMap.get(chId);
                obj.totalViews += views;
                obj.videoCount += 1;
                if (!obj.thumb && v.thumbnails) {
                  obj.thumb = v.thumbnails?.high?.url || v.thumbnails?.medium?.url || v.thumbnails?.default?.url || '';
                }
              }
            }
          }
          if (chMap.size > 0) {
            setChannels(Array.from(chMap.values()).sort((a, b) => b.totalViews - a.totalViews).slice(0, 250));
            setChannelError(null);
          } else {
            setChannelError('API erişim hatası');
          }
        } catch (e2) {
          setChannelError(e2?.message || e?.message || 'Kanal listesi alınamadı');
        }
      } else {
        setChannelError(e?.message || 'Kanal listesi alınamadı');
      }
    } finally {
      setChannelLoading(false);
    }
  };

  useEffect(() => {
    const preset = CHANNEL_PRESETS.find(p => p.id === channelPreset);
    if (preset) fetchChannelsByTopic(preset.queries, preset.categoryId);
  }, [channelPreset]);

  const onChannelSearch = () => {
    if (!channelSearch?.trim()) return;
    fetchChannelsByTopic([channelSearch.trim()], '');
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-12">
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* JAKAMEN — ₺250,000 — Branding Plan 2026                               */}
      {/* YouTube Video • Dizi & Spor Kanalları • Placements • Interest Audiences */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-gradient-to-r from-slate-900 to-slate-800 border-b p-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-xl bg-white px-4 py-2 shadow-sm font-bold text-slate-800 tracking-wide">
              JAKAMEN
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">JAKAMEN — Branding Medya Planı</h1>
              <p className="text-sm text-slate-300 mt-1">
                YouTube Video (Dizi & Spor Kanalları) • YouTube Placements • Programmatic Display • Pinterest Interest • Meta Reach
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1.5 bg-slate-600/50 text-slate-200 text-xs font-medium rounded-full">
              Q1 2026
            </span>
            <span className="inline-flex items-center px-4 py-2 bg-amber-500 text-slate-900 text-sm font-bold rounded-xl">
              Total: ₺250,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube Video</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺75,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">30% • Dizi, spor, eğlence kanalları</p>
            </div>
            <div className="rounded-xl border border-orange-100 bg-orange-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-orange-700">YouTube Placements</span>
              </div>
              <p className="text-xl font-bold text-orange-800">₺50,000</p>
              <p className="text-[10px] text-orange-600 mt-0.5">20% • Hedef kanal yerleşimleri</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Programmatic Display</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺40,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">16% • Interest + New User audiences</p>
            </div>
            <div className="rounded-xl border border-pink-100 bg-pink-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/pinterestlogopng.png" alt="Pinterest" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-pink-700">Pinterest</span>
              </div>
              <p className="text-xl font-bold text-pink-800">₺50,000</p>
              <p className="text-[10px] text-pink-600 mt-0.5">20% • Interest + New User</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Reach</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺35,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">14% • Reach + Interest audiences</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Total Reach</span>
              <p className="text-xl font-bold text-emerald-800">~2.1M</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Tüm kanallar birleşik (aylık)</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — JAKAMEN ₺250K Branding</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign / Targeting</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Metric</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Unit Cost</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Est. Views / Impr.</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* YouTube Video - Dizi, Spor, Eğlence */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/youtubelogov2.svg" alt="YouTube" className="w-5 h-5 object-contain" />
                        <span>YouTube Video</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Dizi Kanalları (Placement targeting)</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.18</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~167K views</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Spor / Futbol Kanalları (Erkek kitle)</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.16</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~188K views</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Eğlence & Lifestyle Kategorisi</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.15</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~100K views</td>
                  </tr>
                  <tr className="bg-red-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-red-800">YouTube Video Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-red-800">₺75,000</td>
                    <td className="px-4 py-3 text-sm text-right text-red-800">~419K views</td>
                  </tr>

                  {/* YouTube Placements */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/youtubelogov2.svg" alt="YouTube" className="w-5 h-5 object-contain" />
                        <span>YouTube Placements</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Hedef Kanal Yerleşimleri (Moda & Lifestyle)</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.22</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺28,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~127K views</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Interest: Moda, Giyim, Erkek Stili</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.20</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺22,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~110K views</td>
                  </tr>
                  <tr className="bg-orange-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-orange-800">YouTube Placements Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-orange-800">₺50,000</td>
                    <td className="px-4 py-3 text-sm text-right text-orange-800">~237K views</td>
                  </tr>

                  {/* Programmatic Display */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                        <span>Programmatic Display</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Interest: Moda, Giyim, Premium Alışveriş</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺32</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺18,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~563K impr.</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">New User / Prospecting Audiences</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺38</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺12,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~316K impr.</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">In-Market: Giyim & Aksesuar</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺35</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺10,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~286K impr.</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Programmatic Display Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺40,000</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">~1.16M impr.</td>
                  </tr>

                  {/* Pinterest */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/pinterestlogopng.png" alt="Pinterest" className="w-5 h-5 object-contain" />
                        <span>Pinterest</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Interest: Moda, Erkek Giyimi, Stil</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺28</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺28,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~1M impr.</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">New User / Actalike Audiences</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺32</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺22,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~688K impr.</td>
                  </tr>
                  <tr className="bg-pink-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-pink-800">Pinterest Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-pink-800">₺50,000</td>
                    <td className="px-4 py-3 text-sm text-right text-pink-800">~1.69M impr.</td>
                  </tr>

                  {/* Meta */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={2}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Reach & Frequency (Interest: Moda, Giyim)</td>
                    <td className="px-4 py-3 text-sm text-right">CPM</td>
                    <td className="px-4 py-3 text-sm text-right">₺14</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺20,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~1.43M reach</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views (New User Interest)</td>
                    <td className="px-4 py-3 text-sm text-right">CPV</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.12</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-600">~125K views</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺35,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">~1.43M reach</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-slate-900 text-white font-bold">
                    <td className="px-4 py-4 text-sm">Grand Total</td>
                    <td className="px-4 py-4 text-sm"></td>
                    <td className="px-4 py-4 text-sm"></td>
                    <td className="px-4 py-4 text-sm"></td>
                    <td className="px-4 py-4 text-sm text-right">₺250,000</td>
                    <td className="px-4 py-4 text-sm text-right">~781K views + ~2.85M impr.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* YouTube Kanal Örnekleri / Channel Finder */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex flex-wrap items-center gap-3">
              <span>YouTube Kanal Örnekleri — Placement hedefleri için kanal bulucu</span>
              <div className="flex items-center gap-2 ml-auto">
                {CHANNEL_PRESETS.map((p) => (
                  <button
                    key={p.id}
                    onClick={() => setChannelPreset(p.id)}
                    className={`px-3 py-1.5 text-xs font-medium rounded-lg transition ${channelPreset === p.id ? 'bg-red-600 text-white' : 'bg-white border border-gray-200 hover:bg-gray-50'}`}
                  >
                    {p.label}
                  </button>
                ))}
                <div className="flex items-center gap-1">
                  <input
                    value={channelSearch}
                    onChange={(e) => setChannelSearch(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && onChannelSearch()}
                    placeholder="Özel arama (örn: süper lig)"
                    className="px-2 py-1.5 text-xs border rounded-lg w-36"
                  />
                  <button onClick={onChannelSearch} className="px-2 py-1.5 text-xs bg-gray-800 text-white rounded-lg hover:bg-gray-700">
                    Ara
                  </button>
                </div>
                <button
                  onClick={selectAllChannels}
                  className="px-2 py-1.5 text-xs font-medium rounded-lg border border-slate-200 bg-white hover:bg-slate-50"
                >
                  Tümünü seç
                </button>
                <button
                  onClick={clearSelection}
                  className="px-2 py-1.5 text-xs font-medium rounded-lg border border-slate-200 bg-white hover:bg-slate-50"
                >
                  Seçimi temizle
                </button>
                <button
                  onClick={() => {
                    const toExport = channels.filter((c) => selectedChannelIds.has(c.channelId));
                    if (toExport.length > 0) exportChannelsToCSV(toExport, CHANNEL_PRESETS.find((p) => p.id === channelPreset)?.label || channelSearch || 'export');
                  }}
                  disabled={channels.length === 0 || selectedChannelIds.size === 0}
                  className="px-3 py-1.5 text-xs font-medium rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
                  title="Sadece işaretli kanalları CSV olarak indir"
                >
                  <span>📥</span> Export CSV {selectedChannelIds.size > 0 ? `(${selectedChannelIds.size})` : ''}
                </button>
              </div>
            </div>
            <div className="p-4 bg-white">
              {channelError && <div className="text-sm text-red-600 mb-3">{channelError}</div>}
              {!getApiKey() && <div className="text-sm text-slate-500 mb-3">API anahtarı yok — Glowytics backend üzerinden kanallar getiriliyor</div>}
              {channelLoading ? (
                <div className="text-sm text-gray-500 py-8 text-center">Kanallar yükleniyor...</div>
              ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                  {channels.map((ch) => (
                    <div
                      key={ch.channelId}
                      className="relative flex flex-col items-center p-3 rounded-lg border hover:border-red-300 hover:bg-red-50/50 transition"
                    >
                      <label className="absolute top-2 right-2 cursor-pointer z-10" onClick={(e) => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          checked={selectedChannelIds.has(ch.channelId)}
                          onChange={() => toggleChannelSelection(ch.channelId)}
                          className="w-4 h-4 rounded border-gray-300 text-red-600 focus:ring-red-500"
                        />
                      </label>
                      <a
                        href={ch.channelId ? `https://www.youtube.com/channel/${ch.channelId}` : '#'}
                        target="_blank"
                        rel="noreferrer"
                        className="flex flex-col items-center w-full"
                      >
                      <img
                        src={ch.thumb || '/youtube.svg'}
                        alt=""
                        className="w-12 h-12 rounded-full object-cover mb-2 bg-gray-100"
                        referrerPolicy="no-referrer"
                        onError={(e) => { e.target.onerror = null; e.target.src = '/youtube.svg'; }}
                      />
                      <span className="text-xs font-medium text-center line-clamp-2 leading-tight">{ch.channelTitle || ch.channelId}</span>
                      {(ch.subs != null || ch.totalViews) && (
                        <span className="text-[10px] text-gray-500 mt-1 truncate w-full block text-center">
                          {ch.subs != null ? `${ch.subs >= 1e6 ? (ch.subs / 1e6).toFixed(1) + 'M' : ch.subs >= 1e3 ? (ch.subs / 1e3).toFixed(0) + 'K' : ch.subs} abone` : ''}
                          {ch.subs != null && ch.totalViews ? ' · ' : ''}
                          {ch.totalViews ? `${ch.totalViews >= 1e6 ? (ch.totalViews / 1e6).toFixed(1) + 'M' : ch.totalViews >= 1e3 ? (ch.totalViews / 1e3).toFixed(0) + 'K' : ch.totalViews} görüntülenme` : ''}
                        </span>
                      )}
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Strategy Summary */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="text-sm font-semibold text-slate-800 mb-2">Hedef Kitle Stratejisi</h3>
              <ul className="text-xs text-slate-600 space-y-1">
                <li>• <strong>New User:</strong> Site ziyaretçisi olmayan, moda/giyim ilgili kitleler</li>
                <li>• <strong>Interest:</strong> Moda, erkek giyimi, premium alışveriş, stil</li>
                <li>• <strong>Placement:</strong> Dizi kanalları, spor/futbol kanalları (erkek kitle), eğlence, lifestyle</li>
                <li>• <strong>Programmatic Display:</strong> GDN üzerinden interest + new user audiences</li>
              </ul>
            </div>
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <h3 className="text-sm font-semibold text-slate-800 mb-2">Kanal Dağılımı</h3>
              <div className="space-y-2 text-xs">
                <div className="flex justify-between"><span>YouTube (Video + Placements)</span><span className="font-semibold">50%</span></div>
                <div className="flex justify-between"><span>Pinterest (Interest + New User)</span><span className="font-semibold">20%</span></div>
                <div className="flex justify-between"><span>Programmatic Display</span><span className="font-semibold">16%</span></div>
                <div className="flex justify-between"><span>Meta (Reach + Video)</span><span className="font-semibold">14%</span></div>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  YouTube Video kampanyaları, placement targeting ile dizi ve spor kanallarına hedeflenebilir. Kanal örnekleri yukarıdaki bulucu ile güncellenebilir.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik ve kreatif performansına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
